import { actionTypes } from "./storeTypes";

export const init_local = {
  fairvalue: { rawdata: [] },
  loading: true,
};

export function local_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_FAIRVALUE: {
      return {
        ...state,
        fairvalue: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
